import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/settings",
      name: "settings",
      meta: { requiresAuth: true, title: "Indstillinger" },
      component: () => import("./main.vue")
    },
    {
      path: "/module/settings/institution",
      name: "institutionsetup",
      meta: { requiresAuth: true, title: "Institution" },
      component: () => import("./institution.vue")
    },
    {
      path: "/module/settings/eventcategories",
      name: "eventcategories",
      meta: { requiresAuth: true, title: "Event Categories" },
      component: () => import("./eventcategories.vue")
    },
    {
      path: "/module/settings/positions",
      name: "positions",
      meta: { requiresAuth: true, title: "Positions" },
      component: () => import("./positions.vue")
    },
    {
      path: "/module/settings/salaryandabsence",
      name: "salaryandabsence",
      meta: { requiresAuth: true, title: "Salary and absence types" },
      component: () => import("./salaryandabsence.vue")
    },
    {
      path: "/module/settings/departments",
      name: "departments",
      meta: { requiresAuth: true, title: "Departments" },
      component: () => import("./departments.vue")
    }
  ]
};
